import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ValidateButton = () => {
  const { t } = useTranslation();

  return (
    <>
      <section className="py-2">
        <div className="container">
          <h2 className="center p-1">{t('Validate Sick Note')}</h2>
          <div className="bottom-line"></div>
          <p className="center mb-3">{t('Verify the authenticity of a sick note issued by Richmond In-Store Medical Clinic')}</p>

          <div className="row">
            <div className="col-lg-6 offset-lg-3">
              <article className="card">
                <div className="center">
                  <h3 className="mb-3">{t('Sick Note Verification')}</h3>
                  <p className="mb-4">{t('Employers and educational institutions can verify that sick notes were legitimately issued by our clinic.')}</p>

                  <Link to="/validate" className="btn btn-primary btn-lg">
                    {t('Validate Sick Note')}
                  </Link>

                  <div className="mt-4">
                    <h5>{t("What You'll Need:")}</h5>
                    <ul className="text-start">
                      <li>{t('Sick Note ID')}</li>
                      <li>{t("Patient's First and Last Name")}</li>
                      <li>{t('Start and End Dates')}</li>
                    </ul>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ValidateButton;
